import { DatePipe } from "@angular/common";
import {
	ChangeDetectorRef,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatStepper } from "@angular/material/stepper";
import { Router } from "@angular/router";
import { PreloaderService } from "@core";
import { DataService } from "@core/bootstrap/data.service";
import { AlertService } from "@shared/components/alert/alert.service";
import { UnitLevelShowComponent } from "@shared/components/unit-level-show/unit-level-show.component";
import { LanguagePipe } from "@shared/pipes/language.pipe";
import { DwsrService } from "../../FORM_PS_TR1/services/dwsr.service";

@Component({
	selector: "app-form-ncr-view",
	templateUrl: "./form-ncr-view.component.html",
	styleUrls: ["./form-ncr-view.component.scss"],
})
export class FormNcrViewComponent implements OnInit {
	@Input() form_key;
	@Input() form_request_id;
	@Input() project_data;
	@Input() supervision_data;
	@Input() template_data;
	allData;
	viewMode: boolean = false;
	transaction_request: any;
	persons: any = [];
	notes: any = [];
	history: any = [];
	collectionSize: any;
	page = 1;
	pageSize = 10;
	form_url = "";
	form: FormGroup;
	lang_key = localStorage.getItem("lang_key");
	platform_code_system: any;
	//stepper
	@ViewChild("stepper") myStepper: MatStepper;
	totalStepsCount: number = 15;
	selectedIndex: number = 0;
	stepProgressValue = 100 / this.totalStepsCount;
	progressValue = this.stepProgressValue;
	stepsTitles = [
		{
			label: `${this.lang.transform("lang_configurations")}`,
			value: "Configurations",
		},
		{
			label: `${this.lang.transform("lang_manager_approval")}`,
			value: "Manager_Approval_Step1",
		},
		{
			label: `${this.lang.transform("lang_contractor_reservation")}`,
			value: "Contractor_Reservation",
		},
		{
			label: `${this.lang.transform("lang_contractor_fixing")}`,
			value: "Contractor_Approval_Step1",
		},
		{
			label: `${this.lang.transform("lang_recipient_verification")}`,
			value: "Recipient_Reservation",
		},
		{
			label: `${this.lang.transform("lang_receipient_team_reply")}`,
			value: "Receipient_Team_Reply",
		},
		{
			label: `${this.lang.transform("lang_manager_approval")}`,
			value: "Manager_Approval_Step2",
		},
		{
			label: `${this.lang.transform("lang_contractor_reservation")}`,
			value: "Contractor_Reservation_Step8",
		},
		{
			label: `${this.lang.transform("lang_contractor_close_NCR")}`,
			value: "Contractor_Close_NCR",
		},
		{
			label: `${this.lang.transform("lang_recipient_reservation")}`,
			value: "Recipient_Reservation_Step10",
		},
		{
			label: `${this.lang.transform("lang_receipient_team_reply")}`,
			value: "Receipient_Team_Reply_Step11",
		},
		{
			label: `${this.lang.transform("lang_manager_approval")}`,
			value: "Manager_Approval_Step3",
		},
		{
			label: `${this.lang.transform("lang_QAQC_reservation")}`,
			value: "QAQC_Reservation",
		},
		{
			label: `${this.lang.transform("lang_QAQC_approval_operation")}`,
			value: "QAQC_Approval_Operation",
		},
		{
			label: `${this.lang.transform("lang_final_result")}`,
			value: "Final_Result",
		},
	];
	stepTitle = this.stepsTitles[this.selectedIndex].label;
	@ViewChild("stepTitleEl", { static: false })
	stepTitleEl?: ElementRef<HTMLElement>;
	varSettimeout: any;
	isLinear: boolean = false;
	showStatus: boolean = false;
	@Output() showAction = new EventEmitter();
	Configurations_Attachments = [];
	Contractor_Manager_Approved_Attachments = [];
	Contractor_Close_NCR_Attachments = [];
	Contractor_Reservation_Step1_files = [];
	Contractor_Reservation_Step8_files = [];
	All_Attachments = [];
	lastStepOpened = "";
	lastStepOpenedShow = "";
	projects_work_area_id = 0;
	template_id: any;
	usersTooltip = "";
	rejected = null;
	expandedStep = 0;
	evaluation_result;
	projects_profile_id: string;
	projects_workarea_id: string;
	manager_contractor_required;
	constructor(
		public ds: DataService,
		public datepipe: DatePipe,
		public dialog: MatDialog,
		private dwsrService: DwsrService,
		public lang: LanguagePipe,
		public spinner: PreloaderService,
		public alert: AlertService,
		public fb: FormBuilder,
		public router: Router,
		public changeDetectorRef: ChangeDetectorRef
	) {
		this.initViewForm();
	}
	ngOnInit(): void {
		this.refreshLists();
	}

	refreshComponent(e) {
		if (e == true) {
			this.initViewForm();
			this.ngOnInit();
		}
	}

	initViewForm() {
		this.form_url = "FORM_NCR";
		this.dwsrService.getData().subscribe(
			(data) => {
				if (data.status) {
					this.allData = data;
					this.projects_profile_id =
						this.allData?.view_request?.work_area_info?.records?.projects_profile_id;
					this.projects_workarea_id =
						this.allData?.view_request?.work_area_info?.records?.projects_work_area_id;
					this.viewMode = this.allData?.view_request?.transactions_request
						?.records?.view_link
						? true
						: false;
					this.persons =
						this.allData?.view_request?.transactions_persons?.records || [];
					this.notes =
						this.allData?.view_request?.transactions_notes?.records || [];
					this.transaction_request =
						this.allData?.view_request?.transactions_request?.records || {};
					this.history =
						this.allData?.view_request?.transactions_records.records || [];
					this.template_id =
						this.allData?.view_request?.form_ncr_data?.records[0]?.template_id;
					this.evaluation_result =
						this.allData?.view_request?.form_ncr_data?.records[0]?.evaluation_result;
					this.platform_code_system =
						this.allData?.view_request?.form_ncr_data?.records[0]?.platform_code_system;
					this.collectionSize = this.history.length;
					this.manager_contractor_required =
						this.allData?.view_request?.form_ncr_data?.records[0]?.manager_contractor_required;
					if (!parseInt(this.manager_contractor_required)) {
						this.stepsTitles = [
							{
								label: `${this.lang.transform("lang_configurations")}`,
								value: "Configurations",
							},
							{
								label: `${this.lang.transform("lang_manager_approval")}`,
								value: "Manager_Approval_Step1",
							},
							{
								label: `${this.lang.transform(
									"lang_contractor_reservation_by_consultant"
								)}`,
								value: "Contractor_Reservation",
							},
							{
								label: `${this.lang.transform("lang_consultant_fixing")}`,
								value: "Contractor_Approval_Step1",
							},
							{
								label: `${this.lang.transform("lang_recipient_verification")}`,
								value: "Recipient_Reservation",
							},
							{
								label: `${this.lang.transform(
									"lang_consultant_confirm_fixing"
								)}`,
								value: "Receipient_Team_Reply",
							},
							{
								label: `${this.lang.transform("lang_manager_approval")}`,
								value: "Manager_Approval_Step2",
							},
							{
								label: `${this.lang.transform(
									"lang_contractor_reservation_by_consultant"
								)}`,
								value: "Contractor_Reservation_Step8",
							},
							{
								label: `${this.lang.transform("lang_contractor_close_NCR")}`,
								value: "Contractor_Close_NCR",
							},
							{
								label: `${this.lang.transform("lang_recipient_verification")}`,
								value: "Recipient_Reservation_Step10",
							},
							{
								label: `${this.lang.transform(
									"lang_consultant_confirm_close_ncr"
								)}`,
								value: "Receipient_Team_Reply_Step11",
							},
							{
								label: `${this.lang.transform("lang_manager_approval")}`,
								value: "Manager_Approval_Step3",
							},
							{
								label: `${this.lang.transform("lang_QAQC_reservation")}`,
								value: "QAQC_Reservation",
							},
							{
								label: `${this.lang.transform("lang_QAQC_approval_operation")}`,
								value: "QAQC_Approval_Operation",
							},
							{
								label: `${this.lang.transform("lang_final_result")}`,
								value: "Final_Result",
							},
						];
					}
					this.lastStepOpened =
						this.allData?.view_request?.transactions_request?.records?.transaction_request_last_step;
					if (this.allData?.view_request?.Configurations_Attachments?.status) {
						this.Configurations_Attachments =
							this.allData?.view_request?.Configurations_Attachments?.records;
					}
					this.All_Attachments = this.Configurations_Attachments || [];
					if (
						this.allData?.view_request?.Contractor_Manager_Approved_Attachments
							?.status
					) {
						this.Contractor_Manager_Approved_Attachments =
							this.allData?.view_request?.Contractor_Manager_Approved_Attachments?.records;
					}
					if (
						this.allData?.view_request?.Contractor_Close_NCR_Attachments?.status
					) {
						this.Contractor_Close_NCR_Attachments =
							this.allData?.view_request?.Contractor_Close_NCR_Attachments?.records;
					}
					if (
						this.allData?.view_request?.Contractor_Reservation_Step1_files
							?.status
					) {
						this.Contractor_Reservation_Step1_files =
							this.allData?.view_request?.Contractor_Reservation_Step1_files?.records;
					}
					if (
						this.allData?.view_request?.Contractor_Reservation_Step8_files
							?.status
					) {
						this.Contractor_Reservation_Step8_files =
							this.allData?.view_request?.Contractor_Reservation_Step8_files?.records;
					}
					let manager_contractor_required =
						this.allData?.view_request?.form_ncr_data?.records[0]
							?.manager_contractor_required;

					if (
						manager_contractor_required == "0" &&
						this.lastStepOpened == "Receipient_Team_Reply"
					) {
						this.All_Attachments = this.All_Attachments.concat(
							...this.Contractor_Manager_Approved_Attachments
						);
					}
					if (
						manager_contractor_required == "0" &&
						this.lastStepOpened == "Receipient_Team_Reply_Step11"
					) {
						this.All_Attachments = this.All_Attachments.concat(
							...this.Contractor_Close_NCR_Attachments
						);
					}
					this.All_Attachments = this.All_Attachments.concat(
						...this.Contractor_Reservation_Step8_files,
						...this.Contractor_Reservation_Step1_files
					);
					this.projects_work_area_id =
						this.allData?.view_request?.work_area_info?.records?.projects_work_area_id;
					this.selectedIndex = this.stepsTitles.findIndex((el) => {
						return el.value == this.lastStepOpened;
					});
					this.lastStepOpenedShow = this.stepsTitles[this.selectedIndex]?.label;
					if (this.lastStepOpened == "last") {
						this.selectedIndex = 14;
						this.lastStepOpenedShow = this.lang.transform("lang_last");
					} else if (this.lastStepOpened == "completed") {
						this.selectedIndex = 14;
						this.lastStepOpenedShow = this.lang.transform("lang_completed");
					}
					this.progressValue =
						this.stepProgressValue * (this.selectedIndex + 1);
					this.get_create_template_options(
						this.projects_work_area_id,
						this.template_id,
						this.platform_code_system
					);
					this.getLastOpenedUsers();
				} else {
					this.alert.error(data.error);
					this.router.navigate(["transactions/allforms"]);
				}
			},
			(err) => {
				this.alert.error(err);
				this.router.navigate(["transactions/allforms"]);
			}
		);
	}

	openUnitLevelModal() {
		const dialogRef = this.dialog.open(UnitLevelShowComponent, {
			disableClose: false,
			width: "600px",
			data: {
				unit_level:
					this.allData?.view_request?.project_supervision_form_unit_level,
			},
		});
	}

	getLastOpenedUsers() {
		let users = this.persons.filter((item) => {
			return item?.transactions_persons_action_status == "0";
		});
		let name = [];
		users.map((el) => {
			name.push(`${el?.first_name} ${el?.last_name}`);
		});
		if (users[users.length - 1]?.transactions_persons_key4 == "REJECTED") {
			this.rejected = this.lang.transform("lang_rejected");
		} else {
			this.rejected = null;
		}
		name = name.filter(this.dwsrService.onlyUnique);
		this.usersTooltip =
			this.lang.transform("lang_users_access_open_step") + " : ";
		for (let i = 0; i < name.length; i++) {
			this.usersTooltip += name[i] + (i == name.length - 1 ? "" : " , ");
		}
	}

	openAccord(index) {
		this.expandedStep = index;
	}

	refreshLists() {
		this.history = this.history
			.map((list, i) => ({
				id: i + 1,
				...list,
			}))
			.slice(
				(this.page - 1) * this.pageSize,
				(this.page - 1) * this.pageSize + this.pageSize
			);
	}

	selectionChange(e: any) {
		this.selectedIndex = e.selectedIndex;
		this.progressValue = this.stepProgressValue * (this.selectedIndex + 1);
		this.stepTitle = this.stepsTitles[this.selectedIndex].label;
	}

	moveStepper(action: string) {
		if (
			action == "next" &&
			this.myStepper.selectedIndex + 1 < this.myStepper.steps.length
		) {
			this.myStepper.selectedIndex++;
		} else if (action == "prev" && this.myStepper.selectedIndex > 0) {
			this.myStepper.selectedIndex--;
		} else {
			return false;
		}
	}

	// current_stepper(step) {
	//   this.currentStep = parseInt(step);
	// }
	public get_create_template_options(
		projects_work_area_id,
		template_id,
		platform_code_system
	) {
		this.spinner.show();
		let param = new FormData();
		param.append(
			"projects_work_area_id",
			this.supervision_data?.projects_work_area_id || projects_work_area_id
		);
		param.append("platform_code_system", platform_code_system);
		param.append("template_id", template_id);
		this.ds
			.postActionByUrl(
				param,
				"form/" + this.form_url + `/cr/0/${this.form_request_id}`
			)
			.subscribe(
				(res) => {
					this.spinner.hide();
					this.showStatus = res.status;
					if (res.status) {
						//
					} else {
						this.ds.dialogf("", res.error);
						this.router.navigate(["transactions/allforms"]);
					}
				},
				(error) => {
					this.spinner.hide();
					this.showStatus = false;
					this.ds.dialogf(
						"",
						error && error.error && error.error.error
							? error.error.error
							: this.lang.transform("lang_internal_server_error")
					);
					this.router.navigate(["transactions/allforms"]);
				}
			);
	}

	public preview_form_data() {
		this.ds.preview_pdf_file(
			"form/" + this.form_key + "/pr/" + this.form_request_id,
			this.form_key + "-" + this.form_request_id
		);
	}

	public view_form_data() {
		this.ds.preview_pdf_file(
			this.transaction_request?.view_link,
			this.form_key + "-" + this.form_request_id
		);
	}

	ngOnDestroy(): void {
		clearTimeout(this.varSettimeout);
	}
}
